import React from 'react';
import { useSelector } from 'react-redux';
import Button from '@cpg-its/ads.common.button';
import { useHistory } from 'react-router';
import { PageContainer } from '../../../../../global/components/layout/page-container';
import { MainContent } from '../../../../../global/components/layout/main-content-container';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { ParticipantEnrollmentSettings } from '../models/epi-props';
import { ButtonWrapper } from '../../../../../../ECDApp/global/components/layout/button-wrapper';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../../constants/routes';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { ParticipantsEnrollmentRoutes } from '../models/routes';

function ExistingParticipantRecord() {

    const participantProps = useSelector<TcsmStates, ParticipantEnrollmentSettings>(state => state?.epiProps?.participantEnrollmentSettingsState?.epiContent);
    const history = useHistory();
    const participantBillingAccountPath = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.BillingAccountsSearch}${ArcRoutes.Participants}`);
    const participantCreateNewRecordPath = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.ParticipantEnrollment}${ParticipantsEnrollmentRoutes.ParticipantRecord}`);

    const handleCancelAction = () => {
        history.push(participantCreateNewRecordPath);
    };

    const handleContinueAction = () => {
        history.push(participantBillingAccountPath);
    };


    return (
        <PageContainer>
            <MainContent>
                <PageHeader
                    headerText={participantProps?.existingParticipantPageTitle}
                    description={participantProps?.existingParticipantPageDescription}
                />
                <ContentSpacer>
                    {participantProps?.existingParticipantContent}
                </ContentSpacer>
                <ContentSpacer>
                    <ButtonWrapper flexEnd>
                        <Button buttonStyle='primary' text={participantProps?.existingParticipantBackButtonText} backgroundColor='#0000FF' onClick={() => handleCancelAction()} />
                        <Button buttonStyle='primary' text={participantProps?.existingParticipantContinueButtonText} backgroundColor='#0000FF' onClick={() => handleContinueAction()} />
                    </ButtonWrapper>
                </ContentSpacer>
            </MainContent>
        </PageContainer>
    );
}

export default ExistingParticipantRecord;